import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { catchError, debounceTime, map, switchMap, tap } from 'rxjs/operators';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { FileService } from 'src/app/shared/services/rest/file.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { TaskService } from 'src/app/shared/services/rest/task.service';
import { ScenariosService } from 'src/app/shared/services/rest/scenarios.service';
import { Overlay } from '@angular/cdk/overlay';
import { AiService } from 'src/app/shared/services/rest/ai.service';
import { ActivatedRoute, Router } from '@angular/router';
import { fromEvent, of } from 'rxjs';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackBarItem } from '../../snack-bar/snack-bar-item';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss']
})
export class ImageEditorComponent extends BaseClass implements OnInit, OnDestroy {
  public imgFile:any = {
    "id": 12831,
    "company_id": 18,
    "task_id": 660,
    "task_operation_id": 0,
    "original": "/file/F/r/main-qimg-6519f699f62aa917378e0335f87f0241-lq.FrP.jpg",
  }

  public m3 = {
    identity: () => [1, 0, 0, 0, 1, 0, 0, 0, 1],
    translation: (tx: number, ty: number) => [1, 0, 0, 0, 1, 0, tx, ty, 1],
    rotation: (angleRad: number) => {
      const c = Math.cos(angleRad), s = Math.sin(angleRad);
      return [c, -s, 0, s, c, 0, 0, 0, 1];
    },
    scaling: (sx: number, sy: number) => [
      sx, 0, 0,
      0, sy, 0,
      0, 0, 1
    ],
    multiply: (a: number[], b: number[]): number[] => {
      // Важно: multiply(b, a) = b * a!
      const out = new Array(9);
      for (let i = 0; i < 3; ++i) for (let j = 0; j < 3; ++j)
        out[i * 3 + j] = a[i * 3 + 0] * b[0 * 3 + j]
                      + a[i * 3 + 1] * b[1 * 3 + j]
                      + a[i * 3 + 2] * b[2 * 3 + j];
      return out;
    }
  };

  @ViewChild('glCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  // currentAngle = 0;
  imageWidth = 0;
  imageHeight = 0;
  offsetX = 0;
  offsetY = 0;

  public mode: any = 'Crop'

  public mods: any = [
    {
      name: "Crop",
      icon: 'crop'
    },
    {
      name: "Finetune",
      icon: 'tune'
    },
    {
      name: "Filter",
      icon: 'palette'
    }
  ]

  public cropRect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  private company: any;
  private isCropped = false;
  public targetAngle: number = 0;
  public currentAngle: number = 0;
  public isRotating: boolean = false;
  public isVisible: boolean = false;

  private gl!: WebGLRenderingContext;
  private program!: WebGLProgram;
  private positionBuffer!: WebGLBuffer;
  private texCoordBuffer!: WebGLBuffer;
  private texture!: WebGLTexture;

  public currentAspectRatio = { w: 0, h: 0 }; // 0:0 означает свободные пропорции

  // private originalBlob: Blob | null = null;

  lastLoadedImage!: HTMLImageElement;
  public exportCanvas: any;
  public data: any;
  public company_id: any = +this.activatedRoute.snapshot.queryParamMap.get('company_id');

  public filters = [
    {
      key: 'original',
      name: 'Original',
      values: {
        brightness: 0,
        contrast: 0,
        saturation: 0,
        exposure: 0,
        temperature: 0,
        gamma: 0,
        clarity: 0,
        vignette: 0,
      }
    },
    {
      key: 'clarendon',
      name: 'Clarendon',
      values: {
        brightness: 5,
        contrast: 15,
        saturation: 20,
        exposure: 5,
        temperature: -5,
        gamma: 10,
        clarity: 10,
        vignette: 5,
      }
    },
    {
      key: 'gingham',
      name: 'Gingham',
      values: {
        brightness: 10,
        contrast: -10,
        saturation: -15,
        exposure: 5,
        temperature: 5,
        gamma: 5,
        clarity: 0,
        vignette: 10,
      }
    },
    {
      key: 'moon',
      name: 'Moon (B&W)',
      values: {
        brightness: 0,
        contrast: 20,
        saturation: -100,
        exposure: 0,
        temperature: 0,
        gamma: 10,
        clarity: 5,
        vignette: 20,
      }
    },
    {
      key: 'lark',
      name: 'Lark',
      values: {
        brightness: 15,
        contrast: -5,
        saturation: 10,
        exposure: 10,
        temperature: 10,
        gamma: 0,
        clarity: 0,
        vignette: 0,
      }
    },
    {
      key: 'reyes',
      name: 'Reyes',
      values: {
        brightness: 10,
        contrast: -10,
        saturation: -30,
        exposure: 0,
        temperature: 0,
        gamma: 0,
        clarity: 5,
        vignette: 5,
      }
    },
    {
      key: 'juno',
      name: 'Juno',
      values: {
        brightness: 10,
        contrast: 15,
        saturation: 20,
        exposure: 5,
        temperature: -5,
        gamma: 0,
        clarity: 5,
        vignette: 0,
      }
    },
    {
      key: 'valencia',
      name: 'Valencia',
      values: {
        brightness: 10,
        contrast: 5,
        saturation: 10,
        exposure: 0,
        temperature: 10,
        gamma: 0,
        clarity: 5,
        vignette: 5,
      }
    },
    {
      key: 'xpro2',
      name: 'X-Pro II',
      values: {
        brightness: 5,
        contrast: 25,
        saturation: 20,
        exposure: 0,
        temperature: 5,
        gamma: 10,
        clarity: 5,
        vignette: 25,
      }
    },
    {
      key: 'nashville',
      name: 'Nashville',
      values: {
        brightness: 10,
        contrast: -5,
        saturation: 15,
        exposure: 0,
        temperature: 20,
        gamma: 5,
        clarity: 0,
        vignette: 5,
      }
    },
    {
      key: 'sepia',
      name: 'Sepia',
      values: {
        brightness: 5,
        contrast: 10,
        saturation: -20,
        exposure: 0,
        temperature: 40,
        gamma: 0,
        clarity: 0,
        vignette: 15,
      }
    },
    {
      key: 'afterglow',
      name: 'Afterglow',
      values: {
        brightness: 10,
        contrast: 10,
        saturation: 15,
        exposure: 5,
        temperature: 10,
        gamma: 10,
        clarity: 5,
        vignette: 10,
      }
    },
    {
      key: 'bw_high_contrast',
      name: 'B&W High Contrast',
      values: {
        brightness: 5,
        contrast: 30,
        saturation: -100,
        exposure: 0,
        temperature: 0,
        gamma: 15,
        clarity: 10,
        vignette: 20,
      }
    },
    {
      key: 'vintage_warm',
      name: 'Vintage Warm',
      values: {
        brightness: 5,
        contrast: -5,
        saturation: -10,
        exposure: 0,
        temperature: 25,
        gamma: 0,
        clarity: 5,
        vignette: 10,
      }
    },
    {
      key: 'cold_breeze',
      name: 'Cold Breeze',
      values: {
        brightness: 10,
        contrast: 5,
        saturation: -10,
        exposure: 5,
        temperature: -25,
        gamma: 10,
        clarity: 0,
        vignette: 10,
      }
    },
    {
      key: 'cinematic',
      name: 'Cinematic',
      values: {
        brightness: -5,
        contrast: 20,
        saturation: 10,
        exposure: 0,
        temperature: -10,
        gamma: 15,
        clarity: 10,
        vignette: 25,
      }
    },
    {
      key: 'pastel_dream',
      name: 'Pastel Dream',
      values: {
        brightness: 15,
        contrast: -10,
        saturation: 5,
        exposure: 5,
        temperature: 5,
        gamma: -5,
        clarity: 0,
        vignette: 5,
      }
    },
    {
      key: 'urban_grit',
      name: 'Urban Grit',
      values: {
        brightness: -5,
        contrast: 25,
        saturation: -5,
        exposure: -5,
        temperature: 0,
        gamma: 10,
        clarity: 20,
        vignette: 15,
      }
    },
    {
      key: 'soft_light',
      name: 'Soft Light',
      values: {
        brightness: 20,
        contrast: -10,
        saturation: 10,
        exposure: 5,
        temperature: 10,
        gamma: -10,
        clarity: -5,
        vignette: 0,
      }
    },
    {
      key: 'golden_hour',
      name: 'Golden Hour',
      values: {
        brightness: 10,
        contrast: 5,
        saturation: 15,
        exposure: 5,
        temperature: 30,
        gamma: 5,
        clarity: 5,
        vignette: 10,
      }
    }
  ];


  // Параметры настройки
  public finetune: any = 'Brightness'
  
  public finetuneParams = [
    { key: 'brightness', name: 'Brightness', value: 0 },
    { key: 'contrast', name: 'Contrast', value: 0 },
    { key: 'saturation', name: 'Saturation', value: 0 },
    { key: 'exposure', name: 'Exposure', value: 0 },
    { key: 'temperature', name: 'Temperature', value: 0 },
    { key: 'gamma', name: 'Gamma', value: 0 },
    { key: 'clarity', name: 'Clarity', value: 0 },
    { key: 'vignette', name: 'Vignette', value: 0 }
  ];
  public vertexShaderSrc = `
  attribute vec2 a_position;
  attribute vec2 a_texCoord;  // Добавлен атрибут для текстурных координат
  uniform vec2 u_resolution;
  uniform mat3 u_matrix;
  varying vec2 v_texCoord;
  
  void main() {
    // Применяем матрицу преобразований к позиции
    vec2 position = (u_matrix * vec3(a_position, 1)).xy;
    
    // Конвертируем из пикселей в clip space [-1, 1]
    vec2 zeroToOne = position / u_resolution;
    vec2 zeroToTwo = zeroToOne * 2.0;
    vec2 clipSpace = zeroToTwo - 1.0;
    
    // WebGL имеет Y вверх, а изображения обычно Y вниз, поэтому инвертируем Y
    gl_Position = vec4(clipSpace, 0, 1);
    
    // Передаем текстурные координаты во фрагментный шейдер
    // v_texCoord = vec2(a_texCoord.x, 1.0 - a_texCoord.y);
    v_texCoord = a_texCoord;
  }
`;

// --- Фрагментный шейдер ---
public fragmentShaderSrc = `
precision highp float;

uniform sampler2D u_texture;
uniform vec4 u_cropRect;
uniform vec2 u_cropScale;

// Finetune uniforms
uniform float u_brightness;
uniform float u_contrast;
uniform float u_saturation;
uniform float u_exposure;
uniform float u_temperature;
uniform float u_gamma;
uniform float u_clarity;
uniform float u_vignette;

varying vec2 v_texCoord;

// Яркость (теперь работает с vec3)
vec3 applyBrightness(vec3 color, float amount) {
  return clamp(color + vec3(amount/100.0), 0.0, 1.0);
}

// Контраст (теперь работает с vec3)
vec3 applyContrast(vec3 color, float amount) {
  return clamp((color - vec3(0.5)) * (1.0 + amount/50.0) + vec3(0.5), 0.0, 1.0);
}

// Насыщенность (остаётся без изменений)
vec3 applySaturation(vec3 color, float amount) {
  float grayscale = dot(color, vec3(0.299, 0.587, 0.114));
  return mix(vec3(grayscale), color, 1.0 + amount/100.0);
}

// Экспозиция (остаётся без изменений)
vec3 applyExposure(vec3 color, float amount) {
  return clamp(color * pow(2.0, amount/50.0), 0.0, 1.0);
}

// Температура (остаётся без изменений)
vec3 applyTemperature(vec3 color, float amount) {
  float temp = amount/100.0;
  return color * vec3(1.0 + temp, 1.0, 1.0 - temp);
}

// Гамма (остаётся без изменений)
vec3 applyGamma(vec3 color, float amount) {
  float gamma = 1.0 + amount/100.0;
  return pow(color, vec3(1.0/gamma));
}

// Vignette (остаётся без изменений)
float applyVignette(vec2 uv, float amount) {
  vec2 center = uv - 0.5;
  float dist = dot(center, center);
  return clamp(1.0 - dist * (abs(amount)/50.0), 0.0, 1.0);
}

void main() {
    // Обработка кадрирования
    vec2 texCoord = v_texCoord;
    
    if (u_cropRect.z > 0.0 && u_cropRect.w > 0.0) {
        texCoord = u_cropRect.xy + v_texCoord * u_cropRect.zw;
        
        if (texCoord.x < 0.0 || texCoord.x > 1.0 || 
            texCoord.y < 0.0 || texCoord.y > 1.0) {
            gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
            return;
        }
    }
    
    vec4 color = texture2D(u_texture, texCoord);
    vec3 result = color.rgb;
    
    if (color.a > 0.0) {
        // Правильный порядок применения эффектов:
        result = applyExposure(result, u_exposure);
        result = applyBrightness(result, u_brightness);
        result = applyContrast(result, u_contrast);
        result = applySaturation(result, u_saturation);
        result = applyTemperature(result, u_temperature);
        result = applyGamma(result, u_gamma);
        
        if (u_vignette != 0.0) {
            float vignette = applyVignette(v_texCoord, u_vignette);
            result *= vignette;
        }
    }
    
    gl_FragColor = vec4(result, color.a);
}
`;

  public host: any = environment.host;
  private dragging = false; 
  private resizing = { active: false, corner: '' }; 
  private dragOffset = { x: 0, y: 0 };

  constructor(
    private activatedRoute: ActivatedRoute,
    public scenariosService: ScenariosService,
    public companyService: CompanyService,
    public taskService: TaskService,
    public fileService: FileService,
    public aiService: AiService,
    public sm: StorageManagerService,
    private sanitizer: DomSanitizer,
    public layoutService: LayoutService,
    public router: Router,
    public overlay: Overlay,
    public viewContainerRef: ViewContainerRef,
  ) { super() }

  ngOnInit(): void {
    console.log("ImageEditorComponent", this.data)
    if (!JSON.parse(this.sm.localStorageGetItem('img_data'))) {
      this.router.navigate(['/main'])
    }
    this.data = JSON.parse(this.sm.localStorageGetItem('img_data'));

    if (window.origin != 'http://localhost:4200') {
      localStorage.removeItem('img_data');
      history.replaceState(null, '', this.data.previusUrl);
    } 

    if (this.data && this.data.file) {
      this.imgFile = this.data.file;
    }

    console.log("ImageEditorComponent 2", this.data)
    this.layoutService.overflowHidden();
    this.downloadFile(this.host + this.imgFile.original + '?company_id=18&download_url=1', this.imgFile);
    this.onResize();
    this.getCompany();
  }

  isActiveFilter(filter) {
    let count = 8;

    Object.keys(filter.values).forEach(key => {
      if (this.finetuneParams.find(k => k.key == key) && this.finetuneParams.find(k => k.key == key).value != filter.values[key]) {
        count--;
      }
    })

    return count == 8
  }

  applyFilter(filter) {
    Object.keys(filter.values).forEach(key => {
      this.finetuneParams.find(p => p.key === key).value = filter.values[key];
    })
    this.applyFinetuneEffects();
  }

  getCompany() {
    this.attachSubscriptions(
      this.companyService.getCompany(this.company_id).subscribe(resp => {
        this.companyService.company$.next(resp[0]);
        this.company = resp[0];
      })
    )
  }

  downloadFile(src, file) {
    this.attachSubscriptions(
      this.fileService.getSrc(src).pipe(
        switchMap((el:any) => {
          return this.fileService.downloadFileFromUrl(el.download_url, file)
        })
      ).subscribe((resp:any) => {
        console.log("downloadFile", resp);
        if (resp.content && resp.state == "DONE") {
          let newSrc = URL.createObjectURL(resp.content);
          file.blobSrc = newSrc;
          file.blob = resp.content;
          this.initGL();
        }
      })
    )
  }

  onResize() {
    this.attachSubscriptions(
      fromEvent(window, "resize").pipe(
        debounceTime(100),
      ).subscribe(() => this.drawScene())
    )
  }
  
  initGL(): void {
    const canvas = this.canvasRef.nativeElement;
    this.gl = canvas.getContext('webgl')!;
    const gl = this.gl;

    // Компиляция и линковка программ
    const vs = this.createShader(gl.VERTEX_SHADER, this.vertexShaderSrc);
    const fs = this.createShader(gl.FRAGMENT_SHADER, this.fragmentShaderSrc);
    this.program = this.createProgram(vs, fs);
    gl.useProgram(this.program);

  // Инициализация uniform-переменных для finetune
    this.finetuneParams.forEach(param => {
      const location = gl.getUniformLocation(this.program, `u_${param.key}`);
      if (location) {
        gl.uniform1f(location, 0); // Начальное значение - 0
      }
    });

    this.positionBuffer = gl.createBuffer()!;
    this.texCoordBuffer = gl.createBuffer()!;

    this.loadTextureFromBlob(this.imgFile.blob).then(() => {
      this.drawScene();
    });
  }

  async loadTextureFromBlob(blob: Blob): Promise<void> {
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => {
        const gl = this.gl;
        this.imageWidth = image.width;
        this.imageHeight = image.height;


        const canvas = gl.canvas as HTMLCanvasElement;
        const scale = Math.min(canvas.width / this.imageWidth, canvas.height / this.imageHeight);

        const displayedWidth = Math.round(this.imageWidth * scale);;
        const displayedHeight = Math.round(this.imageHeight * scale);;
        this.offsetX = (canvas.width - displayedWidth) / 2;
        this.offsetY = (canvas.height - displayedHeight) / 2;   
        
        console.log("displayedHeight", displayedHeight)
        console.log("canvas.height", canvas.height)
        console.log("offsetY", this.offsetY)
        // Например, 80% по самой маленькой из сторон, по центру
      
        this.cropRect.width = displayedWidth * 0.8;
        this.cropRect.height = displayedHeight * 0.8;
        // Центрирование:
        this.cropRect.x = (displayedWidth - this.cropRect.width) / 2;
        this.cropRect.y = (displayedHeight - this.cropRect.height) / 2;


        console.log('webgl imageWidth', this.imageWidth, 'webgl imageHeight', this.imageHeight);
        // Буфер вершин — Квад в пикселях!
        const pos = new Float32Array([
          // Первый треугольник
          0, 0,                // левый верх
          this.imageWidth, 0,  // правый верх
          0, this.imageHeight, // левый низ
          
          // Второй треугольник
          0, this.imageHeight, // левый низ
          this.imageWidth, 0,  // правый верх
          this.imageWidth, this.imageHeight // правый низ
      ]);
        console.log('webgl pos', pos);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.positionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, pos, gl.STATIC_DRAW);

        // UV буфер — тоже в пикселях/нормалях, если нужен uv
        const uv = new Float32Array([
          // Первый треугольник
          0, 0,  // левый верх
          1, 0,  // правый верх
          0, 1,  // левый низ
          
          // Второй треугольник
          0, 1,  // левый низ
          1, 0,  // правый верх
          1, 1   // правый низ
      ]);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.texCoordBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, uv, gl.STATIC_DRAW);

        // Текстура
        this.texture = gl.createTexture()!;
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);

        this.lastLoadedImage = image;
        resolve();
      };
      image.crossOrigin = 'anonymous';
      image.src = URL.createObjectURL(blob);
    });
  }

  private createShader(type: number, source: string): WebGLShader {
    const shader = this.gl.createShader(type)!;
    this.gl.shaderSource(shader, source);
    this.gl.compileShader(shader);
    if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
      throw new Error(this.gl.getShaderInfoLog(shader) || 'Shader compile error');
    }
    return shader;
  }

  private createProgram(vs: WebGLShader, fs: WebGLShader): WebGLProgram {
    const program = this.gl.createProgram()!;
    this.gl.attachShader(program, vs);
    this.gl.attachShader(program, fs);
    this.gl.linkProgram(program);
    if (!this.gl.getProgramParameter(program, this.gl.LINK_STATUS)) {
      throw new Error(this.gl.getProgramInfoLog(program) || 'Program link error');
    }
    return program;
  }

  onAngleChanged(newAngle: number): void {
      this.targetAngle = newAngle;
      if (!this.isRotating) {
          this.animateRotation();
      }
  }

  private animateRotation(): void {
    this.isRotating = true;
    const animate = () => {
        // Плавное приближение к целевому углу
        const angleDelta = this.targetAngle - this.currentAngle;
        this.currentAngle += angleDelta * 0.1; // Коэффициент плавности
        
        this.drawScene();
        
        // Продолжаем анимацию, если не достигли цели
        if (Math.abs(angleDelta) > 0.5) { // Порог остановки
            requestAnimationFrame(animate);
        } else {
            this.currentAngle = this.targetAngle; // Точная установка
            this.drawScene();
            this.isRotating = false;
        }
    };
    requestAnimationFrame(animate);
  }

  private drawScene(): void {
    const gl = this.gl;
    const canvas = gl.canvas as HTMLCanvasElement;
    gl.viewport(0, 0, canvas.width, canvas.height);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);

    gl.useProgram(this.program);

    // Позиции
    const aPosition = gl.getAttribLocation(this.program, 'a_position');
    gl.bindBuffer(gl.ARRAY_BUFFER, this.positionBuffer);
    gl.enableVertexAttribArray(aPosition);
    gl.vertexAttribPointer(aPosition, 2, gl.FLOAT, false, 0, 0);

    // Текстурные координаты
    const aTexCoord = gl.getAttribLocation(this.program, 'a_texCoord');
    gl.bindBuffer(gl.ARRAY_BUFFER, this.texCoordBuffer);
    gl.enableVertexAttribArray(aTexCoord);
    gl.vertexAttribPointer(aTexCoord, 2, gl.FLOAT, false, 0, 0);

    // u_resolution
    const uResolution = gl.getUniformLocation(this.program, 'u_resolution');
    gl.uniform2f(uResolution, canvas.width, canvas.height);

    console.log("this.finetuneParams", this.finetuneParams);

    // Поворот
    const angleRad = this.currentAngle * Math.PI / 180;

    // Масштаб с учетом новых размеров после кропа
    const scale = Math.min(
      canvas.width / this.imageWidth, 
      canvas.height / this.imageHeight
    ) * (this.isCropped ? 1 : 1); // Можете добавить дополнительный масштаб при необходимости

    // Обновленная матрица трансформации
    let matrix = this.m3.identity();
    matrix = this.m3.multiply(matrix, this.m3.translation(-this.imageWidth/2, -this.imageHeight/2));
    matrix = this.m3.multiply(matrix, this.m3.rotation(-angleRad));
    matrix = this.m3.multiply(matrix, this.m3.scaling(scale, scale));
    matrix = this.m3.multiply(matrix, this.m3.scaling(1, -1));
    matrix = this.m3.multiply(matrix, this.m3.translation(canvas.width/2, canvas.height/2));

    const uMatrix = gl.getUniformLocation(this.program, 'u_matrix');
    gl.uniformMatrix3fv(uMatrix, false, new Float32Array(matrix));

    // Текстура
    const uTexture = gl.getUniformLocation(this.program, 'u_texture');
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    gl.uniform1i(uTexture, 0);

    gl.drawArrays(gl.TRIANGLES, 0, 6);
  }
  
  ngOnDestroy(): void {
    this.layoutService.overflowAuto();
    this.clearSubscriptions()

    const gl = this.gl;
    gl.deleteBuffer(this.positionBuffer);
    gl.deleteBuffer(this.texCoordBuffer);
    gl.deleteTexture(this.texture);
    gl.deleteProgram(this.program);
  }

  async cropWithWebGLBest(): Promise<void> {
    const gl = this.gl;
    const canvas = this.canvasRef.nativeElement as HTMLCanvasElement;

    const imageW = this.imageWidth;
    const imageH = this.imageHeight;

    const cropRect = this.cropRect;

    // 1. Масштаб и отступ в canvas
    const scale = Math.min(canvas.width / imageW, canvas.height / imageH);
    const displayedW = imageW * scale;
    const displayedH = imageH * scale;
    const offsetX = (canvas.width - displayedW) / 2;
    const offsetY = (canvas.height - displayedH) / 2;

    // 2. Переводим cropRect в координаты оригинального изображения
    const cropX = ((cropRect.x) / scale);
    const cropY = ((cropRect.y) / scale);
    const cropW = cropRect.width / scale;
    const cropH = cropRect.height / scale;

    const texW = Math.round(cropW);
    const texH = Math.round(cropH);

    // 3. Создаём фреймбуфер
    const targetTexture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, targetTexture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, texW, texH, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    const fb = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, targetTexture, 0);

    if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) !== gl.FRAMEBUFFER_COMPLETE) {
      console.error('Framebuffer not ready');
      return;
    }

    this.finetuneParams.forEach(param => {
      const location = gl.getUniformLocation(this.program, `u_${param.key}`);
      if (location) {        
        gl.uniform1f(location, 0);
      }
    });

    gl.viewport(0, 0, texW, texH);
    gl.clearColor(0.0, 0.0, 0.0, 0.0);
    gl.clear(gl.COLOR_BUFFER_BIT);

    // 4. Матрица трансформации
    const angleRad = this.currentAngle * Math.PI / 180;
    const cropCenterX = cropX + cropW / 2;
    const cropCenterY = cropY + cropH / 2;

    let matrix = this.m3.identity();

    // 1. Перемещаем изображение, чтобы центр оказался в начале координат
    matrix = this.m3.multiply(matrix, this.m3.translation(-imageW / 2, -imageH / 2));

    // 2. Поворот изображения вокруг его центра
    matrix = this.m3.multiply(matrix, this.m3.rotation(-angleRad));

    // 3. Возвращаем центр изображения на место
    matrix = this.m3.multiply(matrix, this.m3.translation(imageW / 2, imageH / 2));

    // 4. Сдвигаем cropRect в начало координат (минус центр cropRect)
    matrix = this.m3.multiply(matrix, this.m3.translation(-cropCenterX, -cropCenterY));

    // 5. Переносим crop в центр output текстуры
    matrix = this.m3.multiply(matrix, this.m3.translation(texW / 2, texH / 2));


    // 5. Применяем uniforms и рендерим
    gl.useProgram(this.program);
    gl.uniformMatrix3fv(gl.getUniformLocation(this.program, 'u_matrix'), false, new Float32Array(matrix));
    gl.uniform2f(gl.getUniformLocation(this.program, 'u_resolution'), texW, texH);
    gl.uniform4f(gl.getUniformLocation(this.program, 'u_cropRect'), 0, 0, 0, 0);

    const uTexture = gl.getUniformLocation(this.program, 'u_texture');
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    gl.uniform1i(uTexture, 0);

    // атрибуты
    const aPos = gl.getAttribLocation(this.program, 'a_position');
    gl.bindBuffer(gl.ARRAY_BUFFER, this.positionBuffer);
    gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

    const aTex = gl.getAttribLocation(this.program, 'a_texCoord');
    gl.bindBuffer(gl.ARRAY_BUFFER, this.texCoordBuffer);
    gl.enableVertexAttribArray(aTex);
    gl.vertexAttribPointer(aTex, 2, gl.FLOAT, false, 0, 0);

    gl.drawArrays(gl.TRIANGLES, 0, 6);

    // 6. Читаем пиксели
    const pixels = new Uint8Array(texW * texH * 4);
    gl.readPixels(0, 0, texW, texH, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.viewport(0, 0, canvas.width, canvas.height);

    // 7. Рисуем результат
    const imageData = new ImageData(new Uint8ClampedArray(pixels), texW, texH);
    const exportCanvas = document.createElement('canvas');
    exportCanvas.width = texW;
    exportCanvas.height = texH;
    const ctx = exportCanvas.getContext('2d');
    if (!ctx) return;
    ctx.putImageData(imageData, 0, 0);
    this.exportCanvas = exportCanvas;

    // 8. Конвертируем и подгружаем
    exportCanvas.toBlob(async (blob) => {
      if (!blob) return;

      this.currentAngle = 0;
      this.isCropped = false;

      await this.loadTextureFromBlob(blob);
      this.updateCropRect();
      // this.resetFinetune(false);
      this.applyFinetuneEffects(false);
      this.drawScene();
    }, 'image/png');
  }



updateCropRect(): void {
  const canvas = this.gl.canvas as HTMLCanvasElement;
  const scale = Math.min(
    canvas.width / this.imageWidth,
    canvas.height / this.imageHeight
  );
  
  const displayedWidth = Math.round(this.imageWidth * scale);
  const displayedHeight = Math.round(this.imageHeight * scale);
  
  // Сохраняем текущий центр (если cropRect уже существует)
  const hasExistingCrop = this.cropRect.width > 0 && this.cropRect.height > 0;
  const currentCenterX = hasExistingCrop ? this.cropRect.x + this.cropRect.width / 2 : displayedWidth / 2;
  const currentCenterY = hasExistingCrop ? this.cropRect.y + this.cropRect.height / 2 : displayedHeight / 2;

  if (this.currentAspectRatio.w > 0 && this.currentAspectRatio.h > 0) {
    // Режим фиксированных пропорций
    const aspect = this.currentAspectRatio.w / this.currentAspectRatio.h;
    
    // Определяем, какая сторона будет лимитирующей (большей)
    if (aspect >= 1) {
      // Ширина будет большой стороной (например 16:9)
      this.cropRect.width = displayedWidth * 0.8;
      this.cropRect.height = this.cropRect.width / aspect;
    } else {
      // Высота будет большой стороной (например 9:16)
      this.cropRect.height = displayedHeight * 0.8;
      this.cropRect.width = this.cropRect.height * aspect;
    }
  } else {
    // Свободный режим - сохраняем текущие пропорции или делаем 80% от обеих сторон
    if (hasExistingCrop) {
      // Сохраняем текущие пропорции
      const currentAspect = this.cropRect.width / this.cropRect.height;
      const maxWidth = displayedWidth * 0.8;
      const maxHeight = displayedHeight * 0.8;
      
      if (currentAspect >= 1) {
        this.cropRect.width = maxWidth;
        this.cropRect.height = maxWidth / currentAspect;
      } else {
        this.cropRect.height = maxHeight;
        this.cropRect.width = maxHeight * currentAspect;
      }
    } else {
      // Первая инициализация - делаем квадрат 80% от меньшей стороны
      const smallerSide = Math.min(displayedWidth, displayedHeight) * 0.8;
      this.cropRect.width = smallerSide;
      this.cropRect.height = smallerSide;
    }
  }

  // Позиционируем по центру (или сохраняем предыдущий центр)
  this.cropRect.x = currentCenterX - this.cropRect.width / 2;
  this.cropRect.y = currentCenterY - this.cropRect.height / 2;
  
  // Гарантируем, что не вышли за границы
  // this.clampCropRect();
}

// Обновление параметров
updateFinetune(val, param: string): void {
  const animate = () => {
    console.log("val", val)
    console.log("param", param)
    const paramObj = this.finetuneParams.find(p => p.key === param);
    if (paramObj) {
      paramObj.value = val;
      this.applyFinetuneEffects();
    }
  };
  requestAnimationFrame(animate);
}

// Применение эффектов
applyFinetuneEffects(draw:boolean = true): void {
  const gl = this.gl;
  gl.useProgram(this.program);
  
  // Устанавливаем uniform-переменные
  this.finetuneParams.forEach(param => {
    const location = gl.getUniformLocation(this.program, `u_${param.key}`);
    if (location) {
      // Нормализуем значения от -100..100 к диапазонам, удобным для шейдера
      let normalizedValue = param.value;
      
      // Специфические корректировки для некоторых параметров
      if (param.key === 'contrast') {
        normalizedValue = param.value * 2.0; // Усиливаем эффект
      }
      
      gl.uniform1f(location, normalizedValue);
    }
  });
  
  if (draw) {
    this.drawScene();
  }
}

checkIfZeroFinetune() {
  return !this.finetuneParams.filter(k => k.value != 0).length
}

async applyFinetuneToTexture(): Promise<void> {
  const gl = this.gl;
  const canvas = this.canvasRef.nativeElement as HTMLCanvasElement;
  const imageW = this.imageWidth;
  const imageH = this.imageHeight;

  // Создаем текстуру того же размера, что и оригинальное изображение
  const texW = imageW;
  const texH = imageH;

  // 1. Создаём фреймбуфер
  const targetTexture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, targetTexture);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, texW, texH, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

  const fb = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, targetTexture, 0);

  if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) !== gl.FRAMEBUFFER_COMPLETE) {
    console.error('Framebuffer not ready');
    return;
  }

  gl.viewport(0, 0, texW, texH);
  gl.clearColor(0.0, 0.0, 0.0, 0.0);
  gl.clear(gl.COLOR_BUFFER_BIT);

  // 2. Матрица трансформации (без поворота и кадрирования)
  let matrix = this.m3.identity();
  // // 1. Перемещаем изображение, чтобы центр оказался в начале координат
  // matrix = this.m3.multiply(matrix, this.m3.translation(-imageW / 2, -imageH / 2));

  // // 3. Возвращаем центр изображения на место
  // matrix = this.m3.multiply(matrix, this.m3.translation(imageW / 2, imageH / 2));

  // // 5. Переносим crop в центр output текстуры
  // matrix = this.m3.multiply(matrix, this.m3.translation(texW / 2, texH / 2));

  // 3. Применяем uniforms и рендерим с эффектами
  gl.useProgram(this.program);
  gl.uniformMatrix3fv(gl.getUniformLocation(this.program, 'u_matrix'), false, new Float32Array(matrix));
  gl.uniform2f(gl.getUniformLocation(this.program, 'u_resolution'), texW, texH);
  gl.uniform4f(gl.getUniformLocation(this.program, 'u_cropRect'), 0, 0, 1, 1); // Полное изображение

  // Устанавливаем параметры Finetune
  this.finetuneParams.forEach(param => {
    const location = gl.getUniformLocation(this.program, `u_${param.key}`);
    if (location) {
      let normalizedValue = param.value;
      
      // Специфические корректировки для некоторых параметров
      if (param.key === 'contrast') {
        normalizedValue = param.value * 2.0; // Усиливаем эффект
      }
      
      gl.uniform1f(location, normalizedValue);
    }
  });

  const uTexture = gl.getUniformLocation(this.program, 'u_texture');
  gl.activeTexture(gl.TEXTURE0);
  gl.bindTexture(gl.TEXTURE_2D, this.texture);
  gl.uniform1i(uTexture, 0);

  // Устанавливаем атрибуты
  const aPos = gl.getAttribLocation(this.program, 'a_position');
  gl.bindBuffer(gl.ARRAY_BUFFER, this.positionBuffer);
  gl.enableVertexAttribArray(aPos);
  gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

  const aTex = gl.getAttribLocation(this.program, 'a_texCoord');
  gl.bindBuffer(gl.ARRAY_BUFFER, this.texCoordBuffer);
  gl.enableVertexAttribArray(aTex);
  gl.vertexAttribPointer(aTex, 2, gl.FLOAT, false, 0, 0);

  gl.drawArrays(gl.TRIANGLES, 0, 6);

  // 4. Читаем пиксели
  const pixels = new Uint8Array(texW * texH * 4);
  gl.readPixels(0, 0, texW, texH, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.viewport(0, 0, canvas.width, canvas.height);

  // 5. Создаем новый canvas с результатом
  const imageData = new ImageData(new Uint8ClampedArray(pixels), texW, texH);
  const exportCanvas = document.createElement('canvas');
  exportCanvas.width = texW;
  exportCanvas.height = texH;
  const ctx = exportCanvas.getContext('2d');
  if (!ctx) return;
  
  // WebGL дает перевернутое изображение, поэтому переворачиваем обратно
  ctx.putImageData(imageData, 0, 0);
  // ctx.scale(1, -1);
  // ctx.drawImage(exportCanvas, 0, -texH);

  this.exportCanvas = exportCanvas;

  // 6. Конвертируем в Blob и обновляем текстуру
  exportCanvas.toBlob(async (blob) => {
    if (!blob) return;

    await this.loadTextureFromBlob(blob);
    this.resetFinetune(false);
    this.drawScene();
  }, 'image/png');
}
  downloadToDevice(saveToReports:boolean = false): void {
    const exportCanvas = this.exportCanvas as HTMLCanvasElement;

    if (!exportCanvas) {
      console.warn('Нет результата crop (exportCanvas is null)');
      return;
    }

    exportCanvas.toBlob((blob) => {
      if (!blob) {
        console.warn('Не удалось создать blob из exportCanvas');
        return;
      }

      if (saveToReports) {
          const blobUrl = URL.createObjectURL(blob);

          let newFrame = {
            blob: blob,
            blobUrl: blobUrl,
            blobSrc: this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl),
            isLoad: true,
          }
          
          this.uploadToReports(this.imgFile, newFrame);
      } else {
        // Генерируем имя файла с текущей датой и временем
        const now = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/[:T]/g, '-');
        const filename = `cropped-${now}.png`;
    
        // Создаём временный URL для blob
        const url = URL.createObjectURL(blob);
    
        // Создаём скрытую ссылку и кликаем по ней
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.style.display = 'none';
    
        document.body.appendChild(a);
        a.click();
    
        // Удаляем ссылку и освобождаем память
        setTimeout(() => {
          URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 100);
      }
    }, 'image/png');
  }

  uploadToReports(file, frame, is_thumb: boolean = false) {
    this.attachSubscriptions(
      this.fileService.uploadFile({
        company_id: file.company_id,
        task_id: file.task_id,
        task_operation_id: file.task_operation_id,
        filesize: frame.blob.size,
        filename: `IE-result-${file.filename.split('.')[0]}.png`,
        content_type: frame.blob.type ? frame.blob.type : 'image/png',
        location: '/image-editor',
        is_dir: 0
      }, this.data.company.id).pipe(
        tap(res => {
          frame.reportsFile = res;
          frame.place = "img_editor";
          frame.url = window.location.href;
          frame.data = res;
          frame.files = [];
          frame.task = undefined;
          frame.work = undefined;
          frame.activeLang = this.data.activeLang;
          frame.location = '/image-editor',
          frame.target = frame.blob;
          frame.user = this.data.user;
          frame.task_id = file.task_id;
          frame.task_operation_id = file.task_operation_id;
          frame.company = this.data.company;
          frame.partition = {
            company_id: file.company_id,
            file_id: file.id,
            consist_of_file_id: frame.reportsFile.id
          };
          frame.company_id = this.data.company.id;
          frame.target_company_id = file.target_company_id;
          this.fileService.files$.next(frame);

          if (is_thumb) {
            file.consists.push(frame);
            file.consists.sort((a, b) => a.time - b.time);
          }
        }),
        catchError((error) => {
          if (error == "Company limit exceeded") {
            this.layoutService.showSnackBar({name: ''}, marker("This company has exceeded the file upload limit."), SnackBarItem)
          } else {
            this.layoutService.showSnackBar({name: ''}, error, SnackBarItem)
          }
          return of(false)
        })
      ).subscribe(resp => {
        console.log(resp)
      })
    )
  }

setAspectRatio(w: number, h: number): void {
  this.currentAspectRatio = { w, h };
  
  if (w === 0 || h === 0) {
    // Free mode - ничего не меняем
    return;
  }

  // Сохраняем текущий центр перед изменением пропорций
  const currentCenterX = this.cropRect.x + this.cropRect.width / 2;
  const currentCenterY = this.cropRect.y + this.cropRect.height / 2;
  
  const canvas = this.gl.canvas as HTMLCanvasElement;
  const scale = Math.min(
    canvas.width / this.imageWidth,
    canvas.height / this.imageHeight
  );
  
  const displayedWidth = this.imageWidth * scale;
  const displayedHeight = this.imageHeight * scale;

  if (w > 0 && h > 0) {
    // Режим фиксированных пропорций
    const aspect = w / h;
    
    // Определяем лимитирующую сторону
    if (aspect >= 1) {
      // Горизонтальный прямоугольник (16:9 и т.п.)
      this.cropRect.width = displayedWidth * 0.8;
      this.cropRect.height = this.cropRect.width / aspect;
    } else {
      // Вертикальный прямоугольник (9:16 и т.п.)
      this.cropRect.height = displayedHeight * 0.8;
      this.cropRect.width = this.cropRect.height * aspect;
    }
  }

  // Восстанавливаем центр
  this.cropRect.x = currentCenterX - this.cropRect.width / 2;
  this.cropRect.y = currentCenterY - this.cropRect.height / 2;
  
  // Корректируем позицию, если вышли за границы
  // this.clampCropRect();
}

  // private clampCropRect(): void {
  //   const canvas = this.gl.canvas as HTMLCanvasElement;
  //   const scale = Math.min(
  //     canvas.width / this.imageWidth,
  //     canvas.height / this.imageHeight
  //   );
    
  //   const displayedWidth = this.imageWidth * scale;
  //   const displayedHeight = this.imageHeight * scale;
    
  //   // Проверяем, чтобы рамка не выходила за пределы изображения
  //   this.cropRect.x = Math.max(0, Math.min(this.cropRect.x, displayedWidth - this.cropRect.width));
  //   this.cropRect.y = Math.max(0, Math.min(this.cropRect.y, displayedHeight - this.cropRect.height));
  // }

  resetFinetune(draw: boolean = true): void {
    this.finetuneParams.forEach(param => param.value = 0)

    this.applyFinetuneEffects(draw);
  }

  resetCrop(): void { 
    if (this.imgFile.blob) { 
      this.currentAngle = 0; 
      this.isCropped = false;
      this.mode = 'Crop';
      this.finetune = 'Brightness';
      this.resetFinetune(false);

      this.loadTextureFromBlob(this.imgFile.blob).then(() => {
        this.updateCropRect();  // заново центрирует рамку
        this.drawScene();       // ререндер изображения
      });
    } else { 
      console.warn('Нет оригинального изображения, reset невозможен'); 
    } 
    
    this.exportCanvas = undefined;
  }

  startCropDrag(event: PointerEvent): void {
    const target = event.target as HTMLElement;

    // Игнорируем начало перетаскивания, если клик был по ручке изменения размера
    if (target.classList.contains('crop-handle')) return;

    const canvasRect = this.canvasRef.nativeElement.getBoundingClientRect();
    const x = event.clientX - canvasRect.left - this.offsetX;
    const y = event.clientY - canvasRect.top - this.offsetY;

    this.dragOffset.x = x - this.cropRect.x;
    this.dragOffset.y = y - this.cropRect.y;
    this.dragging = true;
  }

  onCropDrag(event: PointerEvent): void {
    const canvasRect = this.canvasRef.nativeElement.getBoundingClientRect();
    const x = event.clientX - canvasRect.left - this.offsetX;
    const y = event.clientY - canvasRect.top - this.offsetY;

    if (this.dragging) {
      // Перемещение рамки обрезки
      this.cropRect.x = x - this.dragOffset.x;
      this.cropRect.y = y - this.dragOffset.y;

      this.drawScene(); // Отрисовка после перемещения
    } else if (this.resizing.active) {
      // Изменение размеров рамки обрезки
      this.resizeCrop(x, y, this.resizing.corner);

      this.drawScene(); // Отрисовка после изменения размера
    }
  }

  endCropDrag(): void {
    this.dragging = false;
    this.resizing.active = false;
  }

  startResize(event: PointerEvent, corner: string): void {
    event.stopPropagation(); // Не даём событию всплыть
    event.preventDefault(); // Предотвращаем выделение и прочее

    this.resizing = {
      active: true,
      corner
    };
  }

resizeCrop(mouseX: number, mouseY: number, corner: string): void {
  const r = this.cropRect;
  const fixedAspect = this.currentAspectRatio.w > 0 && this.currentAspectRatio.h > 0;
  const aspectRatio = fixedAspect ? this.currentAspectRatio.w / this.currentAspectRatio.h : 0;
  const minSize = 20;

  const original = { x: r.x, y: r.y, width: r.width, height: r.height };

  switch (corner) {
    case 'top-left': {
      let newRight = original.x + original.width;
      let newBottom = original.y + original.height;
      let newWidth = newRight - mouseX;
      let newHeight = newBottom - mouseY;

      if (fixedAspect) {
        if (newWidth / aspectRatio <= newHeight) {
          newHeight = newWidth / aspectRatio;
        } else {
          newWidth = newHeight * aspectRatio;
        }
      }

      newWidth = Math.max(newWidth, minSize);
      newHeight = Math.max(newHeight, minSize);

      r.x = newRight - newWidth;
      r.y = newBottom - newHeight;
      r.width = newWidth;
      r.height = newHeight;
      break;
    }

    case 'top-right': {
      let newLeft = original.x;
      let newBottom = original.y + original.height;
      let newWidth = mouseX - newLeft;
      let newHeight = newBottom - mouseY;

      if (fixedAspect) {
        if (newWidth / aspectRatio <= newHeight) {
          newHeight = newWidth / aspectRatio;
        } else {
          newWidth = newHeight * aspectRatio;
        }
      }

      newWidth = Math.max(newWidth, minSize);
      newHeight = Math.max(newHeight, minSize);

      r.y = newBottom - newHeight;
      r.width = newWidth;
      r.height = newHeight;
      break;
    }

    case 'bottom-left': {
      let newRight = original.x + original.width;
      let newTop = original.y;
      let newWidth = newRight - mouseX;
      let newHeight = mouseY - newTop;

      if (fixedAspect) {
        if (newWidth / aspectRatio <= newHeight) {
          newHeight = newWidth / aspectRatio;
        } else {
          newWidth = newHeight * aspectRatio;
        }
      }

      newWidth = Math.max(newWidth, minSize);
      newHeight = Math.max(newHeight, minSize);

      r.x = newRight - newWidth;
      r.width = newWidth;
      r.height = newHeight;
      break;
    }

    case 'bottom-right': {
      let newLeft = original.x;
      let newTop = original.y;
      let newWidth = mouseX - newLeft;
      let newHeight = mouseY - newTop;

      if (fixedAspect) {
        if (newWidth / aspectRatio <= newHeight) {
          newHeight = newWidth / aspectRatio;
        } else {
          newWidth = newHeight * aspectRatio;
        }
      }

      newWidth = Math.max(newWidth, minSize);
      newHeight = Math.max(newHeight, minSize);

      r.width = newWidth;
      r.height = newHeight;
      break;
    }
  }

  // Если нужно — зажми рамку в пределах доступной области
  // this.clampCropRect();
}



  @HostListener("window:visibilitychange", ["$event"])
  onVisibilityChange($event) {
    this.isVisible = $event.target.visibilityState === 'visible';
  }

}
